export default "__VITE_ASSET__C9sgX2BU__"